import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import InServiceForm from "../InServiceForm";
import { buildData } from "../utils";

class EditInService extends React.Component {
  state = {
    loading: false,
    saveDisabled: true,
    topic: "",
    startTime: "",
    endTime: "",
    category: "",
    location: "",
    instructors: [],
    selectedCategories: [],
    notes: "",
    generalFiles: [],
    instructorsFiles: [],
    classLimit: "",
    allowSignUps: false,
    status,
    errors: {}
  };

  locations = [...window.Application.currentLocations];

  componentWillMount() {
    const { instructors, selectedCategories, inService, generalFiles, instructorsFiles } = this.props;
    const {
      topic,
      location_id,
      allow_sign_ups,
      class_limit,
      notes,
      start_time,
      end_time,
      status
    } = inService;

    this.locations.unshift({ id: "", name: "No Location Specified" });

    this.setState({
      location: (location_id || "").toString(),
      classLimit: (class_limit || "").toString(),
      allowSignUps: allow_sign_ups,
      startTime: start_time,
      endTime: end_time,
      generalFiles,
      selectedCategories,
      instructorsFiles,
      topic,
      instructors,
      notes,
      status
    });
  }

  handlerChangeCategories = selectedCategories => this.setState({ selectedCategories, errors: {} });

  handlerChangeInstructors = instructors => this.setState({ instructors, errors: {} });

  handleChangeAllowSignUps = e => this.setState({ allowSignUps: e.target.checked, errors: {} });

  handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState({ [name]: value, errors: {} });
  };

  handleAddAttachments = (files, category) =>
    this.setState({[category]: [ ...this.state[category], ...files ]});

  handleDeleteAttachment = (id, index, category) => {
    const files = this.state[category];

    if (files[index].id) {
      files[index]._destroy = true;
    } else {
      files.splice(index, 1);
    }

    this.setState({ [category]: files });
  };

  handleSaveDisabled = (saveDisabled) => {
    this.setState({ saveDisabled })
  }

  submit = () => {
    const { inService, instructors, selectedCategories } = this.props;
    const { id } = inService;
    const data = buildData({ ...this.state }, {
      instructors,
      selectedCategories
    });

    this.setState({ loading: true });
    axios.put(`/in_services/${id}`, data)
      .then(() => {
        toastr.success("Updated.");
        setTimeout(() => {
          window.location.href = "/in_services";
        }, 2500);
      })
      .catch(({ response }) => {
        this.setState({
          loading: false,
          errors: response && response.data && response.data.errors ? response.data.errors : {}
        });
      });
  };

  render() {
    const { categories, defInstructors } = this.props;
    const {
      startTime,
      endTime,
      loading,
      saveDisabled,
      topic,
      location,
      selectedCategories,
      instructors,
      notes,
      generalFiles,
      instructorsFiles,
      allowSignUps,
      classLimit,
      status,
      errors
    } = this.state;

    return (
      <div>
        <h1>Edit In-Service</h1>

        <div className="u-form-width-fix well shadowDepth1">
          <InServiceForm
            errors={errors}
            startTime={startTime}
            endTime={endTime}
            topic={topic}
            location={location}
            locations={this.locations}
            categories={categories}
            selectedCategories={selectedCategories}
            instructors={instructors}
            defInstructors={defInstructors}
            allowSignUps={allowSignUps}
            classLimit={classLimit}
            notes={notes}
            generalFiles={generalFiles}
            instructorsFiles={instructorsFiles}
            status={status}
            onChange={this.handleChange}
            onChangeCategories={this.handlerChangeCategories}
            onChangeInstructors={this.handlerChangeInstructors}
            onChangeAllowSignUps={this.handleChangeAllowSignUps}
            onAddAttachments={this.handleAddAttachments}
            onDeleteAttachment={this.handleDeleteAttachment}
            toggleSaveDisabled={this.handleSaveDisabled}
          />
          <br/>

          <button
            className="btn btn-block btn-pink"
            disabled={loading || saveDisabled}
            onClick={this.submit}
          >
            SAV{loading ? "ING..." : "E"}
          </button>
          <a className="btn btn-block btn-grey" href="/in_services">CANCEL</a>
        </div>
      </div>
    );
  }
}

EditInService.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.any).isRequired,
  categories: PropTypes.array.isRequired,
  defInstructors: PropTypes.array.isRequired,
  inService: PropTypes.object.isRequired,
  instructors: PropTypes.array.isRequired,
  generalFiles: PropTypes.array.isRequired,
  instructorsFiles: PropTypes.array.isRequired
};

export default EditInService;
